var _title, _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReplicate = function SvgReplicate(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M353.28 15.872c-32.256 6.144-60.928 28.16-76.288 57.856-12.288 23.552-13.312 31.744-14.848 109.056l-2.048 83.456h-80.896c-108.032 0-131.072 7.68-155.648 53.76-10.752 20.48-10.752 23.552-10.752 317.44v296.96l12.8 23.040c17.408 30.72 49.664 54.272 83.968 61.44 19.456 4.096 112.64 5.12 303.616 4.096l275.456-1.536 24.576-11.776c17.408-8.704 28.16-18.944 38.4-35.84 13.312-23.552 13.824-26.624 15.36-115.2l2.048-90.624h82.432c76.8 0 84.992-1.024 109.568-12.288 18.432-8.704 30.72-19.456 40.96-34.304l14.336-22.016 1.536-297.472 1.024-296.96-13.824-28.16c-17.408-34.304-44.544-54.272-82.944-61.44-33.792-6.144-536.064-6.144-568.832 0.512zM894.976 390.144l-1.536 252.416-251.904 1.536-252.416 1.024v-506.88h506.88l-1.024 251.904zM262.144 559.104c1.536 184.32 1.536 183.808 30.208 200.704 11.776 7.168 36.352 8.192 180.736 8.192h166.912v128h-501.76v-506.88h122.368l1.536 169.984z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReplicate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/replicate.1bbef2b2.svg";
export { ForwardRef as ReactComponent };